import { render } from "./AgencyCommission.vue?vue&type=template&id=6d4f73a7&scoped=true"
import script from "./AgencyCommission.vue?vue&type=script&lang=js"
export * from "./AgencyCommission.vue?vue&type=script&lang=js"

import "./AgencyCommission.vue?vue&type=style&index=0&id=6d4f73a7&lang=less&scoped=true"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4f73a7"]])

export default __exports__